<template>
    <div class="connect-icons" :class="{ 'connect-icons--center': center }">
        <div
            class="connect-icons__icon connect-icons__icon--application"
            :class="{ 'connect-icons__icon--letter': !showApplicationImage }"
        >
            <img
                v-if="showApplicationImage"
                :src="applicationLogo"
                :alt="applicationName || 'Application logo'"
                class="connect-icons__image"
                @error="applicationLogoErrored = true"
            />
            <span v-else class="connect-icons__letter-text">
                {{ applicationLetter }}
            </span>
        </div>

        <div class="connect-icons__arrow">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>

        <div
            class="connect-icons__icon connect-icons__icon--site"
            :class="{ 'connect-icons__icon--letter': !siteIconSrc }"
        >
            <img
                v-if="siteIconSrc"
                :src="siteIconSrc"
                :alt="siteName"
                class="connect-icons__image"
            />
            <span v-else class="connect-icons__letter-text">
                {{ siteLetter }}
            </span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
    siteIconsRoutes,
    getLogoTypeBySiteId,
    getSiteName,
} from '@/data/site-logos';

export default {
    name: 'ConnectIcons',
    props: {
        applicationLogo: {
            type: String,
            default: null,
        },
        applicationName: {
            type: String,
            default: null,
        },
        siteId: {
            type: String,
            default: null,
        },
        center: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            applicationLogoErrored: false,
        };
    },
    computed: {
        ...mapGetters('ui', ['sites']),
        showApplicationImage() {
            return !!this.applicationLogo && !this.applicationLogoErrored;
        },
        applicationLetter() {
            const name = this.applicationName || 'A';
            return name.trim().charAt(0).toUpperCase() || 'A';
        },
        siteLogoType() {
            return getLogoTypeBySiteId(this.siteId, this.sites);
        },
        siteIconSrc() {
            const type = this.siteLogoType;
            const filename = siteIconsRoutes[type];
            if (!filename) {
                return null;
            }
            return require(`@/assets/images/icons/sites/${filename}.svg`);
        },
        siteName() {
            return getSiteName(this.siteId, this.sites);
        },
        siteLetter() {
            return this.siteName.trim().charAt(0).toUpperCase() || 'E';
        },
    },
    watch: {
        applicationLogo() {
            this.applicationLogoErrored = false;
        },
    },
};
</script>

<style lang="scss">
.connect-icons {
    align-items: center;
    display: flex;
    gap: 16px;
    margin-bottom: 24px;

    &--center {
        justify-content: center;
    }

    &__icon {
        align-items: center;
        background-color: #f1f2f3;
        border-radius: 20px;
        display: flex;
        height: 88px;
        justify-content: center;
        overflow: hidden;
        width: 88px;
    }

    &__icon--application.connect-icons__icon--letter {
        background-color: #14b8a6;
    }

    &__icon--site.connect-icons__icon--letter {
        background-color: #16a34a;
    }

    &__image {
        height: 100%;
        max-height: 64px;
        max-width: 64px;
        object-fit: contain;
        width: 100%;
    }

    &__letter-text {
        color: #ffffff;
        font-size: 36px;
        font-weight: 700;
        line-height: 1;
        text-transform: uppercase;
    }

    &__arrow {
        color: #6b7280;
        display: flex;
    }
}
</style>
